var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _radialGradient, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "0 -29 511.99989 511",
    width: "511pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#445ea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#415a9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    stopColor: "#364d8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a3d7c"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 217.76574063,
    x2: 217.76574063,
    xlinkHref: "#a",
    y1: 13.01275,
    y2: 384.550729253
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 192.8404656062,
    x2: 314.6456191208,
    y1: 168.6539902104,
    y2: 371.6621778326
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#05e5b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5301,
    stopColor: "#13ddac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8322,
    stopColor: "#2ad1a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ac9a0"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 30.2710592816,
    x2: 435.5363000856,
    xlinkHref: "#a",
    y1: 235.4258463524,
    y2: 235.4258463524
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 202.095,
    cy: 191.8795,
    gradientTransform: "matrix(.934149 0 0 1.003922 33.364028 -29.151974)",
    gradientUnits: "userSpaceOnUse",
    r: 183.2894
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3262,
    stopColor: "#fe4672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5324,
    stopColor: "#fb3e6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7054,
    stopColor: "#f52f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    stopColor: "#ee1a51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd00d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#ffcb0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#fb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#ffa215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9517"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 226.2226791658,
    x2: 274.6826968512,
    xlinkHref: "#f",
    y1: 203.8310155216,
    y2: 269.3176507192
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3d7c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3949,
    stopColor: "#273a77",
    stopOpacity: 0.396078
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8504,
    stopColor: "#1e3069",
    stopOpacity: 0.85098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a2b63"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 389.16534369,
    x2: 301.666513936,
    xlinkHref: "#h",
    y1: 226.433014253,
    y2: 138.9342848912
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 -623.345744 -1384.434045)",
    gradientUnits: "userSpaceOnUse",
    x1: 1699.7391,
    x2: 1747.2627,
    xlinkHref: "#f",
    y1: 312.6919,
    y2: 312.6919
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientTransform: "matrix(-.709873 -.709873 -.709873 .709873 1214.048778 452.960478)",
    gradientUnits: "userSpaceOnUse",
    x1: 793.5566,
    x2: 841.0801,
    xlinkHref: "#f",
    y1: 312.6919,
    y2: 312.6919
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 -623.345744 -1384.434045)",
    gradientUnits: "userSpaceOnUse",
    x1: 1764.11,
    x2: 1697.2491,
    y1: 341.5592,
    y2: 274.6984
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9517",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3074,
    stopColor: "#ee8421",
    stopOpacity: 0.305882
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6784,
    stopColor: "#e07728",
    stopOpacity: 0.678431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db722b"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 -623.345744 -1384.434045)",
    gradientUnits: "userSpaceOnUse",
    x1: 1739.9025,
    x2: 1754.6229,
    xlinkHref: "#f",
    y1: 316.3434,
    y2: 316.3434
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#faf8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#eceef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#d5dcea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#b5c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b5d8"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 290.2707945296,
    x2: 316.8892843986,
    xlinkHref: "#n",
    y1: 146.5708183686,
    y2: 170.5275094468
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 320.2061422944,
    x2: 335.922842381,
    xlinkHref: "#h",
    y1: 330.3676534222,
    y2: 277.978385421
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientTransform: "matrix(-.339827 .94469 -.94469 -.339827 1382.432427 -1272.866634)",
    gradientUnits: "userSpaceOnUse",
    x1: 1770.2096,
    x2: 1817.7345,
    xlinkHref: "#f",
    y1: 348.3564,
    y2: 348.3564
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientTransform: "matrix(.339827 -.94469 -.94469 -.339827 503.537644 1171.800446)",
    gradientUnits: "userSpaceOnUse",
    x1: 722.3718,
    x2: 769.894,
    xlinkHref: "#f",
    y1: 348.8333,
    y2: 348.8333
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientTransform: "matrix(-.339827 .94469 -.94469 -.339827 1382.432427 -1272.866634)",
    gradientUnits: "userSpaceOnUse",
    x1: 1810.3718,
    x2: 1825.0938,
    xlinkHref: "#f",
    y1: 352.0074,
    y2: 352.0074
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientTransform: "matrix(.427671 .908248 -.908248 .427671 422.10043 -131.781571)",
    gradientUnits: "userSpaceOnUse",
    x1: 313.9154,
    x2: 340.4239,
    xlinkHref: "#n",
    y1: 250.4863,
    y2: 274.344
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m435.53125 235.425781c0 .941407-.011719 1.875-.019531 2.820313-1.394531 118.964844-91.570313 214.945312-202.609375 214.945312h-40.589844c-106.214844 0-192.3125-97.492187-192.3125-217.765625 0-120.273437 86.097656-217.765625 192.3125-217.765625h40.589844c109.300781 0 198.394531 93.003906 202.480468 209.386719.058594 1.847656.109376 3.703125.128907 5.558594.007812.945312.019531 1.878906.019531 2.820312zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m435.535156 235.425781c0-120.273437-90.71875-217.769531-202.632812-217.769531-111.910156 0-202.632813 97.496094-202.632813 217.769531 0 120.269531 90.722657 217.769531 202.632813 217.769531 111.914062 0 202.632812-97.5 202.632812-217.769531zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m232.902344 17.65625c-111.910156 0-202.632813 97.496094-202.632813 217.769531 0 120.273438 90.722657 217.769531 202.632813 217.769531 111.914062 0 202.632812-97.496093 202.632812-217.769531 0-120.273437-90.722656-217.769531-202.632812-217.769531zm0 378.105469c-82.394532 0-149.1875-71.785157-149.1875-160.335938s66.792968-160.335937 149.1875-160.335937c82.394531 0 149.191406 71.785156 149.191406 160.335937s-66.796875 160.335938-149.191406 160.335938zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m241.746094 117.855469c-60.421875 0-109.398438 52.636719-109.398438 117.570312 0 64.933594 48.976563 117.570313 109.398438 117.570313 60.417968 0 109.394531-52.636719 109.394531-117.570313 0-64.933593-48.976563-117.570312-109.394531-117.570312zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m303.53125 235.425781c0-32.007812-24.144531-57.957031-53.929688-57.957031-29.78125 0-53.925781 25.949219-53.925781 57.957031 0 32.007813 24.144531 57.957031 53.925781 57.957031 29.785157 0 53.929688-25.949218 53.929688-57.957031zm0 0",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m435.535156 235.425781c0-72.25-32.746094-136.269531-83.148437-175.882812-2.9375 7.132812-4.492188 14.835937-4.492188 22.703125l.132813 31.707031-96.554688 96.554687c-2.878906 2.878907-2.878906 7.542969 0 10.421876l144.207032 144.207031c25.039062-36.234375 39.855468-81.113281 39.855468-129.710938zm0 0",
    fill: "url(#i)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m416.222656 56.667969v-48.148438c0-7.128906-8.621094-10.703125-13.664062-5.660156l-37.183594 37.183594c-11.191406 11.191406-17.480469 26.375-17.480469 42.203125l.175781 42.574218zm0 0",
    fill: "url(#j)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m416.222656 56.667969h48.144532c7.132812 0 10.703124 8.621093 5.660156 13.664062l-37.179688 37.179688c-11.195312 11.195312-26.375 17.484375-42.203125 17.484375l-42.574219-.175782zm0 0",
    fill: "url(#k)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m424.898438 114.164062v-57.5h-8.675782l-68.152344 68.15625 42.574219.171876c12.34375 0 24.285157-3.835938 34.253907-10.828126zm0 0",
    fill: "url(#l)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m367.332031 116.003906-10.449219-10.449218 55.410157-55.40625c2.882812-2.886719 7.5625-2.886719 10.449219 0 2.882812 2.882812 2.882812 7.5625 0 10.449218zm0 0",
    fill: "url(#m)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m256.679688 223.085938c-1.886719 0-3.769532-.71875-5.210938-2.160157-2.875-2.875-2.875-7.539062 0-10.417969l104.609375-104.609374c2.878906-2.878907 7.542969-2.878907 10.421875 0 2.875 2.878906 2.875 7.542968 0 10.417968l-104.609375 104.609375c-1.441406 1.441407-3.324219 2.160157-5.210937 2.160157zm0 0",
    fill: "url(#o)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m431.328125 279.765625c-6.777344.648437-13.453125 2.457031-19.730469 5.414063l-28.632812 13.625-128.488282-46.214844c-3.832031-1.378906-8.050781.609375-9.425781 4.4375-.691406 1.914062-.539062 3.925781.265625 5.632812.632813 1.339844 1.667969 2.484375 3.011719 3.25l125.730469 125.734375c28.515625-29.761719 48.910156-68.453125 57.269531-111.878906zm0 0",
    fill: "url(#p)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m463.847656 336.097656 43.558594-20.511718c6.449219-3.039063 6.007812-12.363282-.703125-14.777344l-49.476563-17.796875c-14.894531-5.355469-31.308593-4.578125-45.628906 2.167969l-38.445312 18.292968zm0 0",
    fill: "url(#q)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m463.847656 336.097656 20.511719 43.554688c3.039063 6.453125-3.238281 13.359375-9.953125 10.945312l-49.476562-17.796875c-14.894532-5.359375-27.050782-16.414062-33.792969-30.734375l-17.984375-38.589844zm0 0",
    fill: "url(#r)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m389.335938 317.148438 5-13.90625 73.734374 26.523437c3.839844 1.378906 5.832032 5.613281 4.453126 9.453125-1.382813 3.839844-5.617188 5.832031-9.457032 4.453125zm0 0",
    fill: "url(#s)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m245.316406 262.660156c-.804687-1.707031-.957031-3.71875-.265625-5.632812 1.375-3.828125 5.59375-5.816406 9.425781-4.4375l139.207032 50.070312c3.828125 1.378906 5.816406 5.597656 4.4375 9.425782-1.375 3.828124-5.597656 5.816406-9.425782 4.4375l-139.207031-50.070313c-1.914062-.6875-3.367187-2.085937-4.171875-3.792969zm0 0",
    fill: "url(#t)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTarget);
export default __webpack_public_path__ + "static/media/icon-target.acce3cf8beab31e1261ff2984e5ec79e.svg";
export { ForwardRef as ReactComponent };